// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAyJz8saAKYpfzZqNbzKyr5E7EQyrgUcBk",
  authDomain: "ema-john-simple-e59a9.firebaseapp.com",
  projectId: "ema-john-simple-e59a9",
  storageBucket: "ema-john-simple-e59a9.appspot.com",
  messagingSenderId: "680304267703",
  appId: "1:680304267703:web:7531ffbe753642aaa75832"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;